'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CarouselNavContainer", {
    enumerable: true,
    get: function() {
        return CarouselNavContainer;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCarouselNavContainer = require("./useCarouselNavContainer");
const _renderCarouselNavContainer = require("./renderCarouselNavContainer");
const _useCarouselNavContainerStylesstyles = require("./useCarouselNavContainerStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CarouselNavContainer = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCarouselNavContainer.useCarouselNavContainer_unstable)(props, ref);
    (0, _useCarouselNavContainerStylesstyles.useCarouselNavContainerStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCarouselNavContainerStyles_unstable')(state);
    return (0, _renderCarouselNavContainer.renderCarouselNavContainer_unstable)(state);
});
CarouselNavContainer.displayName = 'CarouselNavContainer';
